import swiper from 'swiper'

const gallerySlider = () => {
    if (!!document.querySelector('.is-style-slider-gallery')) {
        document.querySelectorAll('.is-style-slider-gallery').forEach(gallery => {
           
            replaceGalleryClasses(gallery)
            createNav(gallery)
            
            const slider = new swiper(gallery.querySelector('.swiper-container'), {
                init: false,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination:true,
            })
            activeUnactiveNav({isBeginning: true}, gallery)

            gallery.querySelector('.ia-custom-navigation__swiper-button-next').addEventListener('click', function(e) {
                e.preventDefault()
                slider.slideNext()
            })
            gallery.querySelector('.ia-custom-navigation__swiper-button-prev').addEventListener('click', function(e) {
                e.preventDefault()
                slider.slidePrev()
            })
            slider.init()
        });
    }
}





function replaceGalleryClasses(gallery) {
    const galeryItem = document.createElement('div')
    galeryItem.classList.add('swiper-container', 'is-style-slider-gallery', 'ia-block-slider-gallery')

    const wrapper = document.createElement('div')
    wrapper.setAttribute('class', 'swiper-wrapper')

    const arraySlide = []
    gallery.querySelectorAll('.wp-block-image').forEach(slide => {
        slide.classList.add('swiper-slide')
        slide.classList.remove('wp-block-image')
        arraySlide.push(slide)
        slide.remove()
    })

    arraySlide.forEach(slide => wrapper.append(slide))
    galeryItem.append(wrapper)
    gallery.append(galeryItem)
}





function createNav(gallery) {
    const navContent = document.createElement('div')
    navContent.setAttribute('class', 'ia-custom-navigation')

    const navigation = [
        {
            classNav: 'ia-custom-navigation__swiper-button-prev',
            text: { fr: '<i class="fa-solid fa-angle-left"></i>', en: '<i class="fa-solid fa-angle-left"></i>', de: '<i class="fa-solid fa-angle-left"></i>' }
        },
        {
            classNav: 'ia-custom-navigation__swiper-button-next',
            text: { fr: '<i class="fa-solid fa-angle-right"></i>', en: '<i class="fa-solid fa-angle-right"></i>', de: '<i class="fa-solid fa-angle-right"></i>' }
        }
    ]

    navigation.forEach((elem, i, a) => {
        const link = document.createElement('a')
        link.setAttribute('class', elem.classNav)
        link.setAttribute('href', '#')
        link.innerHTML = elem.text[document.querySelector('html').lang]
        navContent.append(link)
    })
    const pagination = document.createElement('div')
    pagination.classList.add('slider-pagination')
    gallery.querySelector('.swiper-container').append(navContent)
    gallery.appendChild(pagination)
}




function activeUnactiveNav(e, gallery) {
    if (e.isEnd) {
        gallery.querySelector('.ia-custom-navigation__swiper-button-next').classList.add('unactive')
    } else {
        gallery.querySelector('.ia-custom-navigation__swiper-button-next').classList.remove('unactive')
    }

    if (e.isBeginning) {
        gallery.querySelector('.ia-custom-navigation__swiper-button-prev').classList.add('unactive')
    } else {
        gallery.querySelector('.ia-custom-navigation__swiper-button-prev').classList.remove('unactive')
    }
}


export {gallerySlider}